var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpActionFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.376 6.004c.388 0 .665.393.559.767-.232.813-.542 2.191-.542 3.731s.31 2.918.542 3.731c.106.374-.17.767-.559.767H2.142c-.757 0-1.514-1.636-1.514-4.498s.757-4.498 1.514-4.498zM7.934 0c1.381 0 1.974 1.184 1.974 2.763 0 1.184-.395 2.763-.395 2.763h4.003c2.125 0 2.357 2.279 1.072 3.631.214.36.34.778.34 1.227 0 1.069-.7 1.972-1.665 2.284C13.247 13.84 12.455 15 10.5 15H7.736c-1.982 0-2.764-1.052-2.962-1.58-.62-2.065-.591-4.236.199-6.71C6.157 3.949 6.552 2.348 6.749.198 6.764.192 7.349 0 7.934 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpActionFilled);
export default __webpack_public_path__ + "static/media/thumbUpActionFilled.33439583b90b2173ab02b6ca5360ff96.svg";
export { ForwardRef as ReactComponent };